import { EngageLibraryRowModel, EngageLibrarySyncActionEnum } from './engage-library-types';
import { engageLibraryRowKey } from './engage-library-utils';
import { EngageLibraryRow } from './EngageLibraryRow';
import styles from './EngageLibraryTable.module.css';

const EMPTY_STATE = 'No items match your filters.';
const MEMBERSHIP_COLUMN_LABEL = 'On this tenant';

interface EngageLibraryTableProps {
  rows: EngageLibraryRowModel[];
  pendingActionByKey: Map<string, EngageLibrarySyncActionEnum>;
  isSaving: boolean;
  isPending: boolean;
  onToggleRow: (row: EngageLibraryRowModel) => void;
  onRetry: (row: EngageLibraryRowModel) => void;
}

export function EngageLibraryTable({
  rows,
  pendingActionByKey,
  isSaving,
  isPending,
  onToggleRow,
  onRetry,
}: EngageLibraryTableProps) {
  if (rows.length === 0) {
    return <p className={styles.emptyState}>{EMPTY_STATE}</p>;
  }

  return (
    <div className={styles.tableScroll}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th scope="col" className={styles.checkboxCell}>
              <span className={styles.membershipHeader}>{MEMBERSHIP_COLUMN_LABEL}</span>
            </th>
            <th scope="col">Name</th>
            <th scope="col" className={styles.statusHeader}>
              Status
            </th>
            <th scope="col" className={styles.modifiedHeader}>
              Last modified
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map(row => (
            <EngageLibraryRow
              key={engageLibraryRowKey(row)}
              row={row}
              pendingAction={pendingActionByKey.get(engageLibraryRowKey(row))}
              isSaving={isSaving}
              isPending={isPending}
              onToggle={onToggleRow}
              onRetry={onRetry}
            />
          ))}
        </tbody>
      </table>
    </div>
  );
}
